import React from 'react'
import { Card, Divider, Space, Typography } from 'antd'
import { Flight as FlightData } from '../../../../../services/api/orders'
import { displayDate, displayTime } from '../../../../../utils/formatter'
import {
  cityNameByAirportIata,
  airportNameByIata,
} from '../../../../../utils/iata'
import styles from './styles.module.css'
import { CalendarOutlined, ClockCircleOutlined } from '@ant-design/icons'

type Props = {
  flight: FlightData
}
const { Text } = Typography
const { Grid } = Card

export const Flight: React.FunctionComponent<Props> = ({ flight }) => {
  return (
    <Space wrap direction="vertical" className={styles.container}>
      {flight.parts.map((part, number) => (
        <div key={number}>
          {part.segments.map((segment) => {
            const id: string = `${segment.departureAirport}-${segment.arrivalAirport}`
            return (
              <Card
                key={id}
                size="small"
                title={`Полет №${segment.flightNumber}`}
              >
                <Grid hoverable={false} className={styles.grid}>
                  <div className={styles.datetime}>
                    <Text type="secondary" underline>
                      <CalendarOutlined /> {displayDate(segment.departureTime)}
                      <br />
                      <ClockCircleOutlined />{' '}
                      {displayTime(segment.departureTime)}
                    </Text>
                  </div>
                  <Divider className={styles.divider} />
                  {airportNameByIata(segment.departureAirport)} /{' '}
                  {segment.departureAirport}
                  <br />({cityNameByAirportIata(segment.departureAirport)})
                </Grid>
                <Grid hoverable={false} className={styles.grid}>
                  <div className={styles.datetime}>
                    <Text type="secondary" underline>
                      <CalendarOutlined /> {displayDate(segment.arrivalTime)}
                      <br />
                      <ClockCircleOutlined /> {displayTime(segment.arrivalTime)}
                    </Text>
                  </div>
                  <Divider className={styles.divider} />
                  {airportNameByIata(segment.arrivalAirport)} /{' '}
                  {segment.arrivalAirport}
                  <br />({cityNameByAirportIata(segment.arrivalAirport)})
                </Grid>
              </Card>
            )
          })}
        </div>
      ))}
    </Space>
  )
}
